export const NAV_ITEM_KINDS = {
  link: 'link',
  sectionLabel: 'sectionLabel',
}

// Curriculum-service hrefs are program-relative (e.g. /middle-school/lessons)
// while Learn serves programs under /product.
const toLearnRoute = href => `/product${href}`

const isSelectedRoute = (pathname, route) => pathname.includes(route)

const transformLink = ({ link, pathname }) => {
  const route = toLearnRoute(link.href)
  return {
    kind: NAV_ITEM_KINDS.link,
    title: link.label,
    route,
    isSelected: isSelectedRoute(pathname, route),
  }
}

const isRenderableLink = item =>
  item?.kind === NAV_ITEM_KINDS.link && !!item.label && !!item.href

const isRenderableSectionLabel = item =>
  item?.kind === NAV_ITEM_KINDS.sectionLabel && !!item.label

/**
 * Dropdown items for one tab. Only direct children are kept, and classList
 * placeholders are dropped until the frontend fills them from the user's
 * classes. A section label is kept only when a link sits directly under it.
 */
const transformChildren = ({ children, pathname }) => {
  const items = (children || []).reduce((acc, child) => {
    if (isRenderableLink(child)) {
      acc.push(transformLink({ link: child, pathname }))
    } else if (isRenderableSectionLabel(child)) {
      acc.push({ kind: NAV_ITEM_KINDS.sectionLabel, title: child.label })
    }
    return acc
  }, [])

  return items.filter(
    (item, index) =>
      item.kind !== NAV_ITEM_KINDS.sectionLabel ||
      items[index + 1]?.kind === NAV_ITEM_KINDS.link,
  )
}

/**
 * Maps a GET /v1/navigation response to the `programs` shape ProgramNav
 * renders: one entry per tab, each with its dropdown `children`.
 */
export function transformCurriculumNavigation({ navigation, pathname = '' }) {
  return (navigation?.items || []).filter(isRenderableLink).map(item => ({
    ...transformLink({ link: item, pathname }),
    children: transformChildren({ children: item.children, pathname }),
  }))
}
